import { Box } from "@mui/material";
import BaseWidget from "../BaseWidget";

const SingleNumberDisplay = (params) => {
  const renderData = (currentDoorCount) => (
    <Box className="singleNumberDisplay-wrapper">{currentDoorCount}</Box>
  );

  return <BaseWidget {...params} renderData={renderData} />;
};

export default SingleNumberDisplay;
